module.exports = __webpack_public_path__ + "img/sparePartsWarehouse.5a306fa3.svg";